import { logError, loadPersistedErrors } from './utils/errorLogger.js';

export function installGlobalErrorHandlers() {
  loadPersistedErrors();
  if (typeof window === 'undefined') return;

  window.addEventListener('error', (e) => {
    if (e.error) logError(e.error, { type: 'window.error', filename: e.filename, lineno: e.lineno, colno: e.colno });
  });

  window.addEventListener('unhandledrejection', (e) => {
    logError(e.reason || 'unhandledrejection', { type: 'promise.rejection' });
  });
}
